import type { CalculatorMeta } from '../../types/calculator';

const meta: CalculatorMeta = {
  route: '/solar-panel-calculator',
  component: () => import('../../routes/SolarPanelCalculator.svelte'),
  card: {
    id: 'solar-panel',
    title: 'Solar Panel Savings',
    description: 'Estimate how much you can save by installing solar panels. Calculate system cost, tax credits, payback period, and 25-year net savings.',
    icon: 'bolt',
    iconBgClass: 'bg-yellow-50',
    iconTextClass: 'text-yellow-600',
    href: '/solar-panel-calculator',
    category: 'Savings & Investing',
  },
  seo: {
    title: 'Solar Panel Savings Calculator – Estimate Your Solar Energy Savings',
    description: 'Free solar panel savings calculator. Estimate your solar system cost, federal tax credit, monthly savings, payback period, and 25-year net financial benefit.',
  },
};

export default meta;